/**
 * ComparisonPlaceholder — empty-state card used by the F2–F6 comparison
 * panels until each one ships. The container's tab strip routes to one
 * of the real panels (when present) or this placeholder otherwise.
 *
 * Linear: MYD-216 (F1).
 */

import { Card } from 'components/ui/card'
import { Construction } from 'lucide-react'

interface ComparisonPlaceholderProps {
	title: string
	description?: string
	phase?: string
}

const ComparisonPlaceholder = ({
	title,
	description,
	phase,
}: ComparisonPlaceholderProps) => (
	<Card className="p-8 text-center">
		<Construction className="w-8 h-8 mx-auto text-gray-300 mb-3" />
		<h4 className="text-sm font-semibold text-gray-700 mb-1">{title}</h4>
		{description && <p className="text-xs text-gray-500 max-w-md mx-auto">{description}</p>}
		{phase && (
			<p className="text-[10px] uppercase tracking-wide text-gray-400 mt-3">{phase}</p>
		)}
	</Card>
)

export default ComparisonPlaceholder
